<app-header />

<main class="flex-shrink-0">
  <router-outlet />
</main>

<app-faq-footer />
<app-footer />
<app-support-buttons />
